import React, { useState, useMemo } from 'react';
import MaterialTable from 'material-table';
import { IconButton, Tooltip, withStyles, Typography, FormControlLabel, FormGroup, Checkbox, Dialog } from '@material-ui/core';
import { Delete, Refresh } from '@material-ui/icons';
import * as actions from './store/mobileEraseStationActions';
import * as action from '../../sc-core/Auth/store/authActions';
import { BackButton, hasAtLeastOnePermission, hasPermission, localization, getDimensionsOfPagination, formatDate } from '../../sc-utilities';
import { connect } from 'react-redux';
import RemoveMobileEraseStation from './RemoveMobileEraseStation';
import { MuiTableRows } from '../../../themes';
import Toolbar from '../../sc-utilities/Toolbar';
import MobileEraseStationForm from './MobileEraseStationForm';
import * as Yup from "yup";

const styles = theme => ({
    "@global": {
        "[class*='MuiTableCell-root MuiTableCell-body']": {
            height: "40px",
            padding: '2px',
            fontSize: '0.7rem'
        },
    },
    typography: {
        marginTop: '8%'
    },
    title: {
        marginLeft: 14,
        width: "900px"
    },
    tableTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'visible',
        marginTop: '7px'
    },
    customTooltip: {
        marginLeft: -16,
        marginTop: '-2px'
    }
});
let pageSize = 100;
let rowsPageSizeInit = [20, 50, 100];

const MobileEraseStationList = props => {
    const { permissions, classes, translations, fetchMobileEraseStationsCount, bulkDeleteMobileEraseStations, saveColumnsFilter, activeCustomerID, tableColumns, mobileEraseStation, fetchMobileEraseStations, mobileEraseStationDetailsInfo, setMobileEraseStationDetailsInfo, onEditMobileEraseStation, tableRef } = props;
    const [deleteModalState, setDeleteModalState] = useState({ open: false, mobileEraseStationIDs: [] });
    const [checkboxState, setCheckboxState] = useState(false);
    const selectionPermissions = hasAtLeastOnePermission(permissions, ['mobile_erase_station_delete']);

    const fetching = mobileEraseStation.fetching;

    const numberToTake = hasPermission(permissions, 'show_only_not_assigned') ? 325 : 292;
    const columnObject = useMemo(() => tableColumns
        // eslint-disable-next-line react-hooks/exhaustive-deps
        , []); const [tableOptions, setTableOptions] = useState({
            filtering: true,
            sorting: false,
            selection: selectionPermissions,
            search: false,
            minBodyHeight: window.innerHeight - numberToTake < 300 ? 300 : window.innerHeight - numberToTake,
            maxBodyHeight: window.innerHeight - numberToTake,
            pageSizeOptions: rowsPageSizeInit,
            rowStyle: (_rowData, index) => {
                return { backgroundColor: index % 2 ? MuiTableRows.odd : MuiTableRows.even };
            },
            columnsButton: true,
            pageSize: pageSize ? pageSize : 50,
            emptyRowsWhenPaging: false
        });

    const handleCloseSafe = () => {
        setDeleteModalState({ open: false, mobileEraseStationIDs: [] });
    };

    const handleCloseDanger = async () => {
        await bulkDeleteMobileEraseStations({ MobileEraseStationIDs: deleteModalState.mobileEraseStationIDs, ActiveCustomerID: activeCustomerID })
        handleCloseSafe();
        tableRef.current && tableRef.current.onQueryChange()
    };

    const handleBulkDelete = mobileEraseStationIDs => {
        setDeleteModalState({ ...deleteModalState, open: true, mobileEraseStationIDs: mobileEraseStationIDs });
    };

    const filterQuery = filters => {
        let obj = {};
        for (var filter of filters) {
            obj[filter.column.field] = filter.value;
        }
        return obj;
    };

    async function fetchTableData(query) {
        let q = filterQuery(query.filters);
        q['NotAssignedOnly'] = checkboxState;
        query['extendForWEBUI'] = true;
        query['ActiveCustomerID'] = activeCustomerID;
        q['Online'] = q['Online'].map((e) => Number(e));
        query['q'] = q;
        let count = await fetchMobileEraseStationsCount(query);
        if (!query['page'] && query['pageSize'] !== 20 && query['pageSize'] !== 100) {
            let dimensions = getDimensionsOfPagination(count)
            query['pageSize'] = dimensions.pageSize
            rowsPageSizeInit = dimensions.rowsPageSize
            pageSize = dimensions.pageSize
        }
        let result = count ? await fetchMobileEraseStations(query) : [];
        setTableOptions({ ...tableOptions, pageSize: query['pageSize'], pageSizeOptions: rowsPageSizeInit });
        return { data: result, page: query.page, pageSize: pageSize, totalCount: count };
    }


    const columnHidden = newColumnState => {
        let objToSendColumn = {}
        let objColumns = {}
        columnObject.map(column => {
            objColumns[`${column.field}`] = column.hidden;
            return objColumns;
        })
        objToSendColumn[`MobileEraseStation`] = objColumns
        saveColumnsFilter({ ...objToSendColumn, ActiveCustomerID: activeCustomerID })
        return newColumnState
    };

    const handleCheckboxChange = () => {
        setCheckboxState(!checkboxState);
        tableRef.current && tableRef.current.onQueryChange();
    }

    const handleNameChange = (values) => {
        onEditMobileEraseStation({
            Name: values.Name,
            MobileEraseStationID: mobileEraseStationDetailsInfo.MobileEraseStationID,
            HardwareID: values.HardwareID, 
            ActiveCustomerID: activeCustomerID,
        })
        tableRef.current && tableRef.current.onQueryChange();
        setMobileEraseStationDetailsInfo({ open: false })
    }

    const tableTitle = () => {
        return <div className={classes.title}>
            <div className={classes.tableTitle}>
                {BackButton(translations, classes.customTooltip)}
                <Typography> {translations["mobile_erase_stations"] || 'Mobile stations'}</Typography>
                <Tooltip title={translations["refresh"] || "Refresh"}>
                    <IconButton aria-label={translations["refresh"] || "Refresh"} component="div" disabled={fetching} onClick={() => tableRef.current && tableRef.current.onQueryChange()}>
                        <Refresh />
                    </IconButton>
                </Tooltip>
            </div>
            {
                hasPermission(permissions, 'access_all_mobile_erase_stations') ?
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    id="checkbox_locked"
                                    name={"show_only_not_assigned"}
                                    checked={checkboxState}
                                    onChange={handleCheckboxChange}
                                    color={'primary'}
                                />
                            }
                            label={translations["show_only_not_assigned"] || "Show only not assigned"}
                        />
                    </FormGroup>
                    : null
            }
            {mobileEraseStationDetailsInfo.open ?
                <Dialog
                    id="mobile-erase-station-details"
                    open={mobileEraseStationDetailsInfo.open}
                    disableBackdropClick={false}
                    disableEscapeKeyDown={false}
                    disableEnforceFocus={false}
                    fullWidth={true}
                    onClose={() => setMobileEraseStationDetailsInfo({ open: false })}
                >
                    <MobileEraseStationForm
                        formSettings={{
                            ValidationForm: {
                                Name: Yup.string().required("Required")
                            },
                            FormTitle: translations["mobile_erase_station_details"] || "Mobile station details",
                            ButtonSubmit: {
                                Title: translations["save"] || "SAVE"
                            }
                        }}
                        initialValues={{
                            HardwareID: mobileEraseStationDetailsInfo && mobileEraseStationDetailsInfo.HardwareID ? mobileEraseStationDetailsInfo.HardwareID : 'n/a',
                            Name: mobileEraseStationDetailsInfo && mobileEraseStationDetailsInfo.Name ? mobileEraseStationDetailsInfo.Name : '',
                            RemoteID: mobileEraseStationDetailsInfo && mobileEraseStationDetailsInfo.RemoteID ? mobileEraseStationDetailsInfo.RemoteID : '',
                            RemotePassword: mobileEraseStationDetailsInfo && mobileEraseStationDetailsInfo.RemotePassword ? mobileEraseStationDetailsInfo.RemotePassword : '',
                            LicenseName: mobileEraseStationDetailsInfo.License?.Name || 'n/a',
                            ExpiresAt: formatDate(mobileEraseStationDetailsInfo.License?.ExpiresAt) || 'n/a',
                            LicenseStatus: mobileEraseStationDetailsInfo.License && mobileEraseStationDetailsInfo.License.Status ? mobileEraseStationDetailsInfo.License.Status === 'active' ? translations["active"] || "Active" : translations["inactive"] || "Inactive" : 'n/a'
                        }}
                        translations={translations}
                        handleSubmit={handleNameChange}
                    />
                </Dialog>
                : null}
        </div>
    };

    const tableActions = [
        {
            tooltip: `${translations["remove_all_selected"] || "Remove all selected"} ${translations["mobile_erase_stations"] || "Mobile stations"}`,
            icon: <Delete />,
            onClick: (rowData) => handleBulkDelete(rowData.map(mobileEraseStation => mobileEraseStation.EraseStationID))
        }
    ];

    return <>
        <MaterialTable
            components={{
                Toolbar: props => (
                    <Toolbar
                        data={props}
                        actions={tableActions}
                        selectedRows={props.selectedRows}
                        translations={translations}
                    />
                )
            }}
            localization={localization(translations)}
            tableRef={tableRef}
            title={tableTitle()}
            columns={columnObject}
            data={fetchTableData}
            options={tableOptions}
            isLoading={fetching}
            onChangeRowsPerPage={(size) => pageSize = size}
            onChangeColumnHidden={columnHidden}
            onChangePage={() => {if(tableRef?.current?.tableContainerDiv?.current) {tableRef.current.tableContainerDiv.current.scrollTop = 0}}}
        />
        {deleteModalState.open ?
            <RemoveMobileEraseStation handleCloseDanger={handleCloseDanger} handleCloseSafe={handleCloseSafe} translations={translations} deleteModalState={deleteModalState} />
            : null}
    </>
}

const mapDispatchToProps = dispatch => {
    return {
        fetchMobileEraseStationsCount: filter => dispatch(actions.fetchMobileEraseStationsCount(filter)),
        fetchMobileEraseStations: filter => dispatch(actions.fetchMobileEraseStations(filter)),
        bulkDeleteMobileEraseStations: queryParams => dispatch(actions.bulkDeleteMobileEraseStations(queryParams)),
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
        onEditMobileEraseStation: data => dispatch(actions.editMobileEraseStation(data))
    };
};

const mapStateToProps = state => {
    return {
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        mobileEraseStation: state.statistic.mobileEraseStation
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(MobileEraseStationList));